import { render, staticRenderFns } from "./RejectShipment.vue?vue&type=template&id=5aa7466e&scoped=true&"
import script from "./RejectShipment.vue?vue&type=script&lang=js&"
export * from "./RejectShipment.vue?vue&type=script&lang=js&"
import style0 from "./RejectShipment.vue?vue&type=style&index=0&id=5aa7466e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa7466e",
  null
  
)

export default component.exports